import { Page, EntityName, PageSkeleton } from '@/components';
import {
  CryptoIcon,
  Heading,
  BoxProps,
  Flex,
  KpiCard,
  KpiSkeleton,
  TableSkeleton
} from '@blockanalitica/ui';
import { useNetwork } from '@/hooks';
import styled from 'styled-components';
import MarketsTable from './MarketsTable';
import { useApi } from '@/api';

const Title = styled(Heading)<BoxProps>`
  text-transform: capitalize;
`;

type MarketsResponse = {
  total_earn_usd: string | null;
  total_borrow_usd: string | null;
  total_tvl_usd: string | null;
  total_earn_usd_change: string | null;
  total_borrow_usd_change: string | null;
  total_tvl_usd_change: string | null;
  total_supply_usd_change_percentage: string | null;
  total_borrow_usd_change_percentage: string | null;
  total_tvl_usd_change_percentage: string | null;
};

export default function NetworkPage() {
  const network = useNetwork();
  const [data, error] = useApi<MarketsResponse>({
    url: `/markets/kpis/`
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <PageSkeleton>
        <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
          <KpiSkeleton />
          <KpiSkeleton />
          <KpiSkeleton />
        </Flex>
        <TableSkeleton />
      </PageSkeleton>
    );
  }
  return (
    <Page
      title={
        <Title>
          <EntityName
            entitySize="4"
            symbol1={<CryptoIcon name={`${network}_bw`} size="4" />}>
            {network}
          </EntityName>
        </Title>
      }>
      <Flex gap={['s', 'xs']} flexDirection={['column', 'row']}>
        <KpiCard
          title="Total Earning"
          data={data}
          field="total_supply_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Total Borrowing"
          data={data}
          field="total_borrow_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
        <KpiCard
          title="Total Value Locked"
          data={data}
          field="total_tvl_usd"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: 'USD',
                notation: 'compact'
              }
            }
          }}
        />
      </Flex>
      <MarketsTable />
    </Page>
  );
}
